import React, { Fragment } from 'react';
import Link from 'shared/SlashLink';
import usePageSeo from '../../hooks/usePageSeo';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import Indicators, { INDICATOR_CATEGORIES } from '../../data/indicators';

const ClickHandler = () => window.scrollTo(10, 0);

const navy = '#020842';
const blue = '#0044EB';
const gold = '#C77F12';

const catLabel = (key) => (INDICATOR_CATEGORIES.find((c) => c.key === key) || {}).label || 'Indicator';

const IndicatorsHubPage = () => {
    usePageSeo({
        title: 'BuildLab Futures Indicators — TradingView & Tradovate',
        description:
            'Original BuildLab indicators for futures traders — order-flow volume (CVD), session levels, opening range, and risk sizing — free for TradingView and Tradovate.',
        keywords:
            'BuildLab indicators, futures indicators, TradingView Pine Script, Tradovate custom indicators, CVD, cumulative volume delta, opening range, session levels, NQ ES futures',
    });

    return (
        <Fragment>
            <Header />
            <main id="main-content" className="page_content">
                <PageTitle pageTitle={'BuildLab Indicators'} pagesub={'Futures Trading'} pageTop={'Custom Software'} />

                {/* INTRO */}
                <section className="section_space bg-light">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-9 text-center">
                                <h2 className="mb-3" style={{ color: navy }}>Indicators built for how futures actually trade</h2>
                                <p style={{ fontSize: '1.05rem' }}>
                                    A growing suite of original BuildLab indicators — engineered from transparent, standard
                                    market concepts, not black boxes. Every one ships for <b>TradingView (Pine Script v6)</b> and
                                    <b> Tradovate (JavaScript)</b>, with a plain-English guide on how to use it. Download the source,
                                    drop it into your platform, and make it yours.
                                </p>
                            </div>
                        </div>

                        {/* CARDS */}
                        <div className="row mt-4">
                            {Indicators.map((ind) => (
                                <div className="col-lg-4 col-md-6 mb-4" key={ind.id}>
                                    <div style={{ background: '#fff', border: '1px solid #e7e9f2', borderRadius: 16, padding: '26px 26px 22px', height: '100%', display: 'flex', flexDirection: 'column', boxShadow: '0 10px 30px rgba(2,8,66,.06)' }}>
                                        <Link onClick={ClickHandler} to={ind.link || `/indicators/${ind.slug}`} style={{ display: 'block', marginBottom: 16 }}>
                                            <img src={ind.image || `/images/indicators/${ind.slug}.svg`} alt={`${ind.shortName} — BuildLab indicator`} loading="lazy" style={{ width: '100%', aspectRatio: '16 / 9', objectFit: 'cover', borderRadius: 10, display: 'block', border: '1px solid #e7e9f2' }} />
                                        </Link>
                                        <div style={{ fontSize: '.72rem', fontWeight: 700, letterSpacing: '.07em', textTransform: 'uppercase', color: gold }}>
                                            {catLabel(ind.category)}
                                            {ind.free !== false && <span style={{ marginLeft: 8, color: '#0a7d2c', background: 'rgba(16,160,60,.12)', borderRadius: 20, padding: '2px 9px', fontSize: '.66rem' }}>FREE</span>}
                                        </div>
                                        <h3 className="h5 mt-2 mb-2" style={{ color: navy }}>
                                            <Link onClick={ClickHandler} to={ind.link || `/indicators/${ind.slug}`} style={{ color: navy }}>{ind.shortName}</Link>
                                        </h3>
                                        <p style={{ fontSize: '.92rem', flexGrow: 1 }}>{ind.tagline}</p>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, margin: '6px 0 16px' }}>
                                            {ind.platforms.map((p) => (
                                                <span key={p} style={{ fontSize: '.7rem', fontWeight: 600, color: blue, background: 'rgba(0,68,235,.08)', borderRadius: 20, padding: '3px 10px' }}>{p}</span>
                                            ))}
                                        </div>
                                        <Link onClick={ClickHandler} to={ind.link || `/indicators/${ind.slug}`} className="btn btn-primary" style={{ alignSelf: 'flex-start' }}>
                                            <span className="btn_label" data-text="View & download">View &amp; download</span>
                                            <span className="btn_icon"><i className="fa-solid fa-arrow-up-right" aria-hidden="true"></i></span>
                                        </Link>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <p className="text-center mt-2" style={{ fontSize: '.85rem', color: '#6b7280' }}>
                            More indicators are being added to the suite. Educational tools only — not financial advice.
                        </p>
                    </div>
                </section>

                <CtaSection />
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default IndicatorsHubPage;
